import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment, { Moment } from 'moment';
import { DatePipe } from '../date.pipe';
import { NgbDateToDatePipe } from './ngb-date-to-date.pipe';

@Injectable({
  providedIn: 'root',
})
export class NgbDateParserFormatterService extends NgbDateParserFormatter {
  constructor(
    private datePipe: DatePipe,
    private ngbDateToDatePipe: NgbDateToDatePipe,
  ) {
    super();
  }

  public format(date: NgbDateStruct | null): string {
    return date
      ? this.datePipe.transform(this.ngbDateToDatePipe.transform(date)) || ''
      : '';
  }

  public parse(value: string): NgbDateStruct | null {
    let date: Moment;
    try {
      date = moment(value);
    } catch (e) {
      return null;
    }

    return {
      year: date.year(),
      month: date.month(),
      day: date.day(),
    };
  }
}
